<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>{{ $t('message.containers') }}</h3>
      </div>
    </div>
    <div class="card">
      <div class="card__title">
        <h5>{{ $t('message.informacionConsulta') }}</h5>
      </div>
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12">
            <div class="form-inline">
              <div class="form-field">
                <label for="todosContenedores">
                  <input
                    v-model="form.todos_contenedores"
                    type="checkbox"
                    name="todosContenedores"
                    id="todosContenedores"
                  />
                  <span>Todos los contenedores</span>
                </label>
              </div>
              <div v-show="!form.todos_contenedores" class="form-field select2">
                <div class="select2-field">
                  <v-select
                    :tooltip="tooltipContenedores"
                    @input="inputContenedores"
                    :options="contenedoresFiltradosPorPatio"
                    label="number"
                    v-model="selectedContenedores"
                    multiple
                    id="contenedor"
                    placeholder="Seleccione..."
                  ></v-select>
                  <label for="contenedor">{{ $t('message.containers') }}</label>
                </div>
              </div>
              <div class="form-field select">
                <div class="select-field">
                  <select
                    v-model="form.pendiente_estado"
                    name="pendientesEstado"
                    id="pendientesEstado"
                  >
                    <option value="T">Todos</option>
                    <option value="IN">Gate IN</option>
                    <option value="EST">Estimar</option>
                    <option value="REP">Reparar</option>
                    <option value="OUT">Despachar</option>
                  </select>
                  <label for="pendientesEstado">Pendientes por</label>
                </div>
              </div>
              <div v-show="form.pendiente_estado === 'T'" class="form-field select2">
                <div class="select2-field select2-field--stretch">
                  <v-select
                    @input="inputTiposEstado"
                    v-model="selectedTiposEstado"
                    label="descripcion"
                    :options="tiposEstado"
                    id="tiposEstado"
                    multiple
                    placeholder="Seleccione..."
                  ></v-select>
                  <label for="tiposEstado">Tipo de estado</label>
                </div>
              </div>
              <div class="form-field">
                <label for="todasLineas">
                  <input
                    v-model="form.todas_lineas"
                    type="checkbox"
                    name="todasLineas"
                    id="todasLineas"
                  />
                  <span>{{ $t('message.todasLineas') }}</span>
                </label>
              </div>
              <div v-show="!form.todas_lineas" class="form-field select2">
                <div class="select2-field select2-field--stretch">
                  <v-select
                    :tooltip="selectedLinea !== null?selectedLinea.nombre:null"
                    @input="inputLinea"
                    :options="lineas"
                    label="nombre"
                    v-model="selectedLinea"
                    id="linea"
                    placeholder="Seleccione..."
                  ></v-select>
                  <label for="linea">{{ $t('message.lineas') }}</label>
                </div>
              </div>
              <div class="form-field">
                <label for="todosPatios">
                  <input
                    v-model="form.todos_patios"
                    type="checkbox"
                    name="todosPatios"
                    id="todosPatios"
                  />
                  <span>Todos los patios</span>
                </label>
              </div>
              <div v-show="!form.todos_patios" class="form-field select2">
                <div class="select2-field select2-field--stretch">
                  <v-select
                    :tooltip="selectedPatio !== null?selectedPatio.nombre:null"
                    @input="inputPatio"
                    :options="patios"
                    label="name"
                    v-model="selectedPatio"
                    id="patio"
                    placeholder="Seleccione..."
                  ></v-select>
                  <label for="linea">Patios</label>
                </div>
              </div>
              <button class="btn-info" @click="consultar(true)">
                <i class="fa fa-search"></i>
                <span>{{ $t('message.buscar') }}</span>
              </button>
              <button class="btn-success" @click="exportar">
                <i class="fa fa-file-excel-o"></i>
                <span>Excel</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card mt-3">
      <div class="card__title">
        <h5>{{ $t('message.resultados') }}</h5>
      </div>
      <div class="card__content">
        <strong v-show="registros.length === 0">{{ $t('message.sinDatos') }}</strong>
        <div class="row" v-show="registros.length > 0">
          <div class="col-xs-12" v-for="registro in registros" :key="registro.number">
            <item-dashboard :contenedor="registro"></item-dashboard>
          </div>
        </div>
        <div class="row center-xs">
          <button
            @click="mostrarMas"
            type="button"
            v-show="form.todos_contenedores && consultaActual.length > 0 && form.registrosTotales > 0"
            class="btn-info"
          >
            <i class="fa fa-eye"></i>
            <span>{{ $t('message.mostrar_mas') }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    tooltipContenedores: function() {
      let tooltip = "";
      for (let i = 0; i < this.selectedContenedores.length; i++)
        tooltip +=
          (tooltip === "" ? "" : ", ") + this.selectedContenedores[i].number;
      return tooltip !== "" ? tooltip : null;
    },
    contenedoresFiltrados: function() {
      let filtrados = [];
      for (let i = 0; i < this.contenedores.length; i++)
        if (
          this.form.todas_lineas ||
          this.selectedLinea === null ||
          this.contenedores[i].customer_code == this.selectedLinea.code
        )
          filtrados.push(this.contenedores[i]);
      return filtrados;
    },
    contenedoresFiltradosPorPatio: function() {
      let filtrados = [];
      for (let i = 0; i < this.contenedoresFiltrados.length; i++)
        if (
          this.form.todos_patios ||
          this.selectedPatio === null ||
          this.contenedoresFiltrados[i].yard_code == this.selectedPatio.code
        )
          filtrados.push(this.contenedoresFiltrados[i]);
      return filtrados;
    }
  },
  props: {
    patios: {
      type: Array,
      required: false,
      default: function() {
        return [];
      }
    },
    contenedores: {
      type: Array,
      required: false,
      default: function() {
        return [];
      }
    },
    lineas: {
      type: Array,
      required: false,
      default: function() {
        return [];
      }
    }
  },
  data: function() {
    return {
      patioDefault: '',
      tiposEstado: [
        {
          id: "IN",
          descripcion: "Gate IN"
        },
        {
          id: "I",
          descripcion: "Inspeccionado"
        },
        {
          id: "EST",
          descripcion: "Estimado"
        },
        {
          id: "A",
          descripcion: "Aprobado"
        },
        {
          id: "R",
          descripcion: "Reparado"
        }
      ],
      selectedPatio: null,
      selectedLinea: null,
      selectedTiposEstado: [],
      selectedEstadosPendientes: [],
      form: {
        pendiente_estado: "T",
        tipos_estado: [],
        todas_lineas: true,
        cantidadRegistros: 10,
        todos_contenedores: true,
        contenedores: [],
        registrosTotales: 0,
        linea_id: "",
        todos_patios: true,
        patio_id: ""
      },
      registros: [],
      consultaActual: [],
      selectedContenedores: []
    };
  },
  methods: {
    inputTiposEstado: function() {
      this.form.tipos_estado.splice(0, this.form.tipos_estado.length);
      for (let i = 0; i < this.selectedTiposEstado.length; i++)
        this.form.tipos_estado.push(this.selectedTiposEstado[i].id);
    },
    inputPatio: function() {
      if (this.selectedPatio !== null)
        this.form.patio_id = this.selectedPatio.code;
      else this.form.patio_id = "";
    },
    toParams: function(obj) {
      return (
        "?" +
        Object.keys(obj)
          .reduce(function(a, k) {
            let val = obj[k];
            let esArray = false;
            if (val instanceof Date) {
              val = val.toLocaleDateString("en");
            } else if (val instanceof Array) {
              esArray = true;
              let acumulador = "";
              for (let i = 0; i < val.length; i++) {
                acumulador += k + "%5B%5D=" + val[i];
                if (i != val.length - 1) {
                  acumulador += "&";
                }
              }
              val = acumulador;
              a.push(val);
            }
            if (!esArray) a.push(k + "=" + encodeURIComponent(val));
            return a;
          }, [])
          .join("&")
      );
    },
    exportar: function() {
      let params = this.toParams(this.form);
      window.open(url + "/home" + params + "&exportar=E", "_blank");
    },
    inputLinea: function() {
      if (this.selectedLinea !== null)
        this.form.linea_id = this.selectedLinea.code;
      else this.form.linea_id = "";
    },
    mostrarMas: function() {
      this.consultar();
    },
    inputContenedores: function() {
      let contenedores = [];
      if (this.selectedContenedores.length > 0)
        for (let i = 0; i < this.selectedContenedores.length; i++)
          contenedores.push(this.selectedContenedores[i].number);
      this.form.contenedores = contenedores;
    },
    consultar: function(boton = false) {
      if (boton) {
        this.form.registrosTotales = 0;
        this.registros.splice(0, this.registros.length);
      }
      let that = this;
      if (!boton) {
        let xmlhttp = new XMLHttpRequest();
        xmlhttp.onreadystatechange = function() {
          if (
            (this.readyState == 4 && this.status == 200) ||
            this.status == 201
          ) {
            let json = JSON.parse(this.responseText);
            that.consultaActual = json;
            if (that.form.todos_contenedores)
              that.form.registrosTotales += that.consultaActual.length;
            else {
              that.form.registrosTotales = 0;
              that.registros.splice(0, that.registros.length);
            }
            for (let i = 0; i < that.consultaActual.length; i++)
              that.registros.push(that.consultaActual[i]);
          }
        };
        xmlhttp.open(
          "GET",
          url + "/home" + this.toParams(this.form) + "&web=true",
          true
        );
        xmlhttp.send();
      } else
        axios
          .get(url + "/home", {
            params: this.form
          })
          .then(function(response) {
            that.consultaActual = response.data;
            if (that.form.todos_contenedores)
              that.form.registrosTotales += that.consultaActual.length;
            else {
              that.form.registrosTotales = 0;
              that.registros.splice(0, that.registros.length);
            }
            for (let i = 0; i < that.consultaActual.length; i++)
              that.registros.push(that.consultaActual[i]);
          });
    }
  },
  mounted: function() {
    this.patioDefault = patioDefault;
    if (this.patioDefault != '' && this.patioDefault != null) {
      this.form.todos_patios = false;
      for (let i = 0; i < this.patios.length; i++) {
        if (this.patios[i].code == this.patioDefault) {
          this.selectedPatio = this.patios[i];
          this.inputPatio();
        }
      }
    }
    this.consultar();
    let that = this;
    setInterval(function() {
      that.consultar();
    }, 30 * 1000);
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/Dashboard.vue